const toggleSearchModalButton = (modal, isOpen) => {
  const targetId = modal.getAttribute("id");
  if (!targetId) {
    return;
  }

  const toggle = document.querySelector(
    `.search-modal-toggle[data-bs-target="#${targetId}"]`
  );
  if (!toggle) {
    return;
  }

  const labelOpen =
    toggle.getAttribute("data-label-open") || "Open search";
  const labelClose =
    toggle.getAttribute("data-label-close") || "Close search";

  toggle.classList.toggle("is-open", isOpen);
  toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
  toggle.setAttribute("aria-label", isOpen ? labelClose : labelOpen);
};

const toggleInlineButton = (toggle, isOpen) => {
  const labelOpen =
    toggle.getAttribute("data-label-open") || "Open search";
  const labelClose =
    toggle.getAttribute("data-label-close") || "Close search";

  toggle.classList.toggle("is-open", isOpen);
  toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
  toggle.setAttribute("aria-label", isOpen ? labelClose : labelOpen);
};

const focusSearchInput = (container) => {
  const input = container.querySelector('input[type="text"]');
  if (input) {
    input.focus();
    input.select();
  }
};

const getInlinePanel = (toggle) => {
  const panel = toggle.nextElementSibling;
  if (panel && panel.classList.contains("search-modal-inline")) {
    return panel;
  }
  return null;
};

const getMenuContainer = (toggle) =>
  toggle.closest(".navbar-collapse");

export const initSearchModal = () => {
  const mobileQuery = window.matchMedia("(max-width: 991.98px)");

  document.addEventListener("shown.bs.modal", (event) => {
    const modal = event.target;
    if (!modal.classList.contains("search-modal")) {
      return;
    }

    modal.removeAttribute("inert");
    toggleSearchModalButton(modal, true);
    focusSearchInput(modal);
  });

  document.addEventListener("hidden.bs.modal", (event) => {
    const modal = event.target;
    if (!modal.classList.contains("search-modal")) {
      return;
    }

    modal.setAttribute("inert", "");
    toggleSearchModalButton(modal, false);
  });

  document.addEventListener("click", (event) => {
    const toggle = event.target.closest(".search-modal-toggle");
    if (!toggle || !mobileQuery.matches) {
      return;
    }

    const panel = getInlinePanel(toggle);
    if (!panel) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const isOpen = panel.classList.contains("is-open");
    panel.classList.toggle("is-open", !isOpen);
    panel.setAttribute("aria-hidden", isOpen ? "true" : "false");
    if (isOpen) {
      panel.setAttribute("inert", "");
    } else {
      panel.removeAttribute("inert");
    }
    toggleInlineButton(toggle, !isOpen);

    const menuContainer = getMenuContainer(toggle);
    if (menuContainer) {
      menuContainer.classList.toggle("search-inline-open", !isOpen);
    }

    if (!isOpen) {
      focusSearchInput(panel);
    }
  }, true);

  const closeInlinePanels = () => {
    const panels = document.querySelectorAll(".search-modal-inline.is-open");
    panels.forEach((panel) => {
      panel.classList.remove("is-open");
      panel.setAttribute("aria-hidden", "true");
      panel.setAttribute("inert", "");
      const toggle = panel.previousElementSibling;
      if (toggle && toggle.classList.contains("search-modal-toggle")) {
        toggleInlineButton(toggle, false);
        const menuContainer = getMenuContainer(toggle);
        if (menuContainer) {
          menuContainer.classList.remove("search-inline-open");
        }
      }
    });
  };

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener("change", (event) => {
      if (!event.matches) {
        closeInlinePanels();
      }
    });
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener((event) => {
      if (!event.matches) {
        closeInlinePanels();
      }
    });
  }

  const openModals = document.querySelectorAll(".search-modal.show");
  openModals.forEach((modal) => {
    toggleSearchModalButton(modal, true);
    focusSearchInput(modal);
  });
};
